import { deepFreeze } from '@shared/lib/deepFreeze';
import PropTypes from 'prop-types';
import React from 'react';
import { animated, useSpring } from 'react-spring';
import styled from 'styled-components';
import ImgDiscoverCard from './discover-card.jpg';
import { rotate } from './style-utils';

export function SVG(props) {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props.children}
    </svg>
  );
}

export function Share(props) {
  return (
    <SVG className={props.className} viewBox="0 0 35 35">
      <g fill="none" fillRule="evenodd">
        <circle cx="17.5" cy="17.5" r="17.5" />
        <path
          d="M24.94 17.717a1.5 1.5 0 0 1 1.5 1.5v4.92a1.5 1.5 0 0 1-1.347 1.493l-.154.008H10.061a1.5 1.5 0 0 1-1.492-1.347l-.008-.153v-4.92a1.5 1.5 0 0 1 2.992-.154l.008.153v3.42h11.878v-3.42a1.5 1.5 0 0 1 1.5-1.5Zm-7.091-9.133c.13.046.26.138.347.228l2.96 3.176c.216.228.325.524.325.82 0 .297-.13.547-.325.73a1.022 1.022 0 0 1-.76.318c-.282 0-.564-.114-.759-.318L18.56 12.23v6.143c0 .615-.463 1.058-1.07 1.058s-1.069-.421-1.069-1.058v-6.166l-1.077 1.33a1.022 1.022 0 0 1-.76.319c-.302 0-.563-.09-.758-.319a1.19 1.19 0 0 1-.325-.797c0-.32.13-.57.325-.752l2.894-3.176c.022-.023.065-.045.087-.068.022 0 .022-.023.065-.046a.953.953 0 0 1 .977-.114Z"
          fill={props.color ?? 'currentColor'}
        />
      </g>
    </SVG>
  );
}

export function AngleDown(props) {
  return (
    <SVG className={props.className} viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <circle cx="12" cy="12" r="12" />
        <g transform="rotate(90 12 12)" stroke={props.color ?? 'currentColor'} strokeLinecap="round" strokeWidth="3">
          <path d="M11.224 8.297l2.845 3.57M11.224 15.569l2.845-3.57" />
        </g>
      </g>
    </SVG>
  );
}

export const Arrow = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 30" {...props}>
      <path
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="6"
        d="M3.8 14.9h27M21.7 3.5l9.1 11.2M21.7 26.3L30.8 15"
      />
    </svg>
  );
};

export const ArrowDown = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle cx="18" cy="18" r="18" />
        <path
          d="M16.993 28.57l-7.528-7.525A1.602 1.602 0 019 19.915c0-.407.186-.751.465-1.003a1.487 1.487 0 011.084-.438c.403 0 .806.157 1.084.438l4.895 4.955.001-15.331C16.53 7.69 17.18 7 18.047 7s1.517.659 1.517 1.536v15.362l4.803-4.985a1.487 1.487 0 011.084-.439c.433 0 .806.125 1.084.439.279.281.465.69.465 1.097 0 .44-.186.784-.465 1.035l-7.434 7.525c-.032.032-.094.063-.124.095-.031 0-.031.032-.093.062-.403.314-.96.344-1.395.157a1.359 1.359 0 01-.496-.314z"
          fill={props.color ?? 'currentColor'}
        />
      </g>
    </svg>
  );
};

export const VerticalArrow = (props) => {
  return (
    <svg viewBox="0 0 18 22" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.993 21.57L.465 14.045A1.602 1.602 0 0 1 0 12.915c0-.407.186-.751.465-1.003a1.487 1.487 0 0 1 1.084-.438c.403 0 .806.157 1.084.438l4.895 4.955.001-15.331C7.53.69 8.18 0 9.047 0s1.517.659 1.517 1.536v15.362l4.803-4.985a1.487 1.487 0 0 1 1.084-.439c.433 0 .806.125 1.084.439.279.281.465.69.465 1.097 0 .44-.186.784-.465 1.035l-7.434 7.525c-.032.032-.094.063-.124.095-.031 0-.031.032-.093.062-.403.314-.96.344-1.395.157a1.359 1.359 0 0 1-.496-.314z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const Chevron = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M8 0a8 8 0 110 16A8 8 0 018 0z" />
        <path
          d="M11.134 1.116a1.25 1.25 0 01.091 1.666l-.091.102-5.117 5.115 5.117 5.117a1.25 1.25 0 01-1.666 1.859l-.102-.091-6-6a1.25 1.25 0 01-.091-1.666l.091-.102 6-6a1.25 1.25 0 011.768 0z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};

export const Church = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 58" {...props}>
      <g fill="currentColor" fillRule="nonzero">
        <path d="M59.6 25L31.3 1.3c-.5-.5-1.3-.5-1.8 0L1.2 25A1.4 1.4 0 1 0 3 27l3.6-3v32.5c0 .8.6 1.4 1.4 1.4h44.8c.8 0 1.4-.6 1.4-1.4V24l3.6 3a1.4 1.4 0 0 0 1.8-2.1zm-8.2-2.4v32.6h-42V22.4 22l21-17.7L51.5 22l-.1.7z" />
        <path d="M29 23.7v4h-4.4a1.4 1.4 0 1 0 0 2.9H29v10a1.4 1.4 0 1 0 2.8 0v-10h4.4a1.4 1.4 0 1 0 0-2.8h-4.4v-4a1.4 1.4 0 1 0-2.8 0z" />
      </g>
    </svg>
  );
};

export const Circle = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94 94" {...props}>
      <circle cx="47" cy="47" r="47" fill="currentColor" />
    </svg>
  );
};

export const Collapse = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle cx="25" cy="25" r="25" />
        <g transform="rotate(-45 43.228 7.55)" fill="currentColor">
          <path d="M14.557 7.99l-5.921 5.554A1.693 1.693 0 017.472 14c-.42 0-.775-.183-1.033-.456a1.426 1.426 0 01-.452-1.065c0-.396.161-.791.452-1.065L9.71 8.5H1.5C.628 8.5 0 7.85 0 7c0-.852.596-1.5 1.5-1.5h8.243L6.439 2.586a1.426 1.426 0 01-.452-1.065c0-.425.129-.791.452-1.065.29-.273.71-.456 1.13-.456.454 0 .808.183 1.067.456l5.921 5.463c.033.031.065.092.097.121 0 .031.033.031.065.092.323.396.354.943.161 1.37a1.328 1.328 0 01-.323.487z" />
          <path
            d="M21.443 6.01L27.364.457A1.693 1.693 0 0128.528 0c.42 0 .775.183 1.033.456.29.274.452.64.452 1.065 0 .396-.161.791-.452 1.065L26.29 5.5H34.5c.872 0 1.5.65 1.5 1.5 0 .852-.596 1.5-1.5 1.5h-8.243l3.304 2.914c.29.274.452.64.452 1.065 0 .425-.129.791-.452 1.065-.29.273-.71.456-1.13.456-.454 0-.808-.183-1.067-.456L21.443 8.08c-.033-.031-.065-.092-.097-.121 0-.031-.033-.031-.065-.092-.323-.396-.354-.943-.161-1.37.064-.183.194-.365.323-.487z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
};

export const Expand = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle cx="25" cy="25" r="25" />
        <path
          d="M11.886 36.715l.26-8.114c.013-.444.202-.849.5-1.146a1.408 1.408 0 011.053-.408c.398-.012.771.133 1.072.433.28.28.446.674.434 1.073l-.254 4.375 5.806-5.807c.617-.616 1.52-.601 2.122 0 .602.603.639 1.483 0 2.122L17.05 35.07l4.397-.275c.399-.012.772.132 1.072.433.301.3.469.65.434 1.072-.012.399-.18.825-.477 1.123-.32.32-.7.441-1.077.43l-8.05.325c-.045.002-.11-.019-.154-.017-.022-.022-.045.002-.11-.019-.509-.051-.918-.416-1.083-.855a1.328 1.328 0 01-.116-.573z"
          fill="currentColor"
        />
        <path
          d="M36.715 11.886l-8.114.26a1.693 1.693 0 00-1.146.5 1.408 1.408 0 00-.408 1.053c-.012.398.133.771.433 1.072.28.28.674.446 1.073.434l4.375-.254-5.807 5.806c-.616.617-.601 1.52 0 2.122.603.602 1.483.639 2.122 0l5.828-5.829-.275 4.397c-.012.399.132.772.433 1.072.3.301.65.469 1.072.434.399-.012.825-.18 1.123-.477.32-.32.441-.7.43-1.077l.325-8.05c.002-.045-.019-.11-.017-.154-.022-.022.002-.045-.019-.11-.051-.509-.416-.918-.855-1.083a1.328 1.328 0 00-.573-.116z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const TriggerIconNucleusLogo = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" {...props}>
      <g id="nucleus-logo" fill="currentColor" fillRule="evenodd">
        <circle cx="30" cy="30" r="30" fill="none" />
        <path d="M41.497 18.377c.336 0 .608.272.608.608v22.164l-.008.098a.608.608 0 01-1.003.356l-10.907-9.677-.082-.083a.85.85 0 01.646-1.404h1.75l.2-.005a3.991 3.991 0 003.792-3.987v-5.264l.005-.17a2.806 2.806 0 012.801-2.636zm-22.99-.133c.15 0 .293.054.404.153l10.907 9.677.082.083a.85.85 0 01-.646 1.404h-1.75l-.2.005a3.991 3.991 0 00-3.792 3.987v5.264l-.005.17a2.806 2.806 0 01-2.8 2.636h-2.2l-.098-.008a.608.608 0 01-.509-.6V18.851l.008-.098a.608.608 0 01.6-.51z" />
      </g>
    </svg>
  );
};

export const TriggerIconNextSteps = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" {...props}>
      <g fill="currentColor" fillRule="evenodd">
        <circle cx="30" cy="30" r="30" fill="none" />
        <path
          d="M18.886 27.875v-6.417l4.02 6.417h2.3v-9.763h-2.175v5.935l-3.663-5.935h-2.644v9.763h2.162zm10.887.207c1.735 0 2.823-.992 3.153-2.176l-1.749-.496c-.193.538-.62.896-1.377.896-.812 0-1.515-.551-1.556-1.322h4.765c.013-.042.04-.358.04-.648 0-2.203-1.307-3.511-3.428-3.511-1.776 0-3.415 1.405-3.415 3.608 0 2.3 1.68 3.649 3.567 3.649zm1.253-4.448h-2.74c.04-.51.481-1.157 1.363-1.157.991 0 1.35.634 1.377 1.157zm4.4 4.241c.372-.564.882-1.377 1.254-1.927l1.267 1.927h2.45c-.784-1.101-1.68-2.396-2.45-3.497l2.368-3.347h-2.34l-1.199 1.873-1.226-1.873h-2.464l2.396 3.43-2.355 3.414h2.3zm8.491.124c.661 0 1.006-.151 1.088-.192V26.07c-.124.028-.33.07-.55.07-.455 0-.758-.152-.758-.717v-2.561h1.336v-1.832h-1.336v-1.996h-1.873v.881c0 .634-.344 1.115-1.06 1.115h-.344v1.832h1.211v2.933c0 1.363.868 2.203 2.286 2.203zM17.512 40.672c2.327 0 3.607-1.556 3.607-3.084 0-1.391-.964-2.59-2.823-2.934l-1.308-.247c-.674-.124-.964-.469-.964-.937 0-.537.524-1.046 1.336-1.046 1.184 0 1.556.77 1.625 1.225l1.955-.55c-.206-1.144-1.129-2.603-3.566-2.603-1.873 0-3.498 1.294-3.498 3.14 0 1.445 1.005 2.547 2.658 2.864l1.336.248c.647.123 1.046.482 1.046.977 0 .606-.523 1.02-1.377 1.02-1.336 0-1.942-.786-2.024-1.68l-1.997.481c.138 1.377 1.295 3.126 3.994 3.126zm7.457-.082c.661 0 1.006-.152 1.088-.193v-1.735c-.124.027-.33.068-.55.068-.455 0-.758-.151-.758-.716v-2.56h1.336v-1.832h-1.336v-1.997h-1.873v.881c0 .634-.344 1.116-1.06 1.116h-.344v1.831h1.212v2.933c0 1.364.867 2.204 2.285 2.204zm5.186.082c1.735 0 2.823-.991 3.154-2.176l-1.75-.495c-.192.537-.619.895-1.376.895-.813 0-1.515-.551-1.556-1.322h4.764c.014-.042.042-.358.042-.647 0-2.204-1.309-3.512-3.43-3.512-1.776 0-3.414 1.405-3.414 3.608 0 2.3 1.68 3.65 3.566 3.65zm1.253-4.448h-2.74c.041-.51.482-1.156 1.363-1.156.992 0 1.35.633 1.377 1.156zm5.062 6.858v-3.153c.317.385.978.688 1.86.688 1.913 0 3.263-1.5 3.263-3.594 0-2.052-1.198-3.567-3.181-3.567-.978 0-1.721.427-2.01.868v-.702h-2.025v9.46h2.093zm1.515-4.338c-.812 0-1.542-.578-1.542-1.707 0-1.143.73-1.694 1.542-1.694.826 0 1.556.55 1.556 1.694 0 1.143-.73 1.707-1.556 1.707zm6.88 1.928c1.831 0 2.726-1.143 2.726-2.313 0-1.006-.688-1.86-2.107-2.149l-.909-.179c-.303-.055-.537-.22-.537-.509 0-.358.345-.592.744-.592.633 0 .923.385.978.84l1.735-.317c-.07-.799-.758-2.038-2.74-2.038-1.53 0-2.63 1.02-2.63 2.272 0 .964.578 1.79 2.037 2.107l.785.18c.51.11.675.316.675.564 0 .303-.262.592-.799.592-.716 0-1.046-.455-1.074-.923l-1.776.317c.055.757.743 2.148 2.892 2.148z"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};

export const TriggerIconPlus = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" {...props}>
      <g fill="currentColor" fillRule="evenodd" transform="translate(0 .5)">
        <circle cx="30" cy="30" r="30" fill="none" />
        <path d="M30 17.6a2.754 2.754 0 00-2.756 2.756v6.888h-6.888A2.754 2.754 0 0017.6 30a2.754 2.754 0 002.756 2.756h6.888v6.888A2.754 2.754 0 0030 42.4a2.754 2.754 0 002.756-2.756v-6.888h6.888A2.754 2.754 0 0042.4 30a2.754 2.754 0 00-2.756-2.756h-6.888v-6.888A2.754 2.754 0 0030 17.6z" />
      </g>
    </svg>
  );
};

export const TriggerIconFootprints = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" {...props}>
      <g fill="currentColor" fillRule="evenodd">
        <circle cx="30" cy="30" r="30" fill="none" />
        <path
          d="M32.803 38.864l5.98 1.713c-.168 2.122-1.025 5.223-2.988 6.202-3.074 1.631-6.149-1.716-4.1-5.96.258-.652.768-1.549 1.111-1.958l-.003.003zm-5.631-8.082c.764.855 1.7 3.168 1.785 4.539.17 3.171-2.212 5.312-4.766 3.855-2.041-1.2-2.72-4.195-2.976-6.594.85-.172 4.85-1.457 5.957-1.8zm9.717-10.046c1.062-.25 2.206-.085 2.94.34.82.504 1.227 1.098 1.637 1.942.652 1.434 1.062 4.478.898 6.336-.25 2.03-1.394 7.943-3.108 9.38-.328.255-.656.086-1.39-.169l-4.168-1.013c-.652-.17-.652-.34-.898-.93-.57-2.027-.734-4.139-.734-6.505.082-2.536 1.062-6.17 2.698-8.028.41-.424 1.308-1.183 2.125-1.353zM20.165 13.26c.735-.424 2.044-.594 2.942-.34.899.17 1.716.846 2.208 1.356 1.636 1.864 2.535 5.5 2.617 8.125 0 2.37-.164 4.4-.735 6.431-.328 1.016-.574.846-2.289 1.27-.98.251-1.88.506-2.778.676-.243.085-.489.17-.735.17-.492.17-.656.254-1.39-1.015-.41-.68-.817-1.78-1.063-2.54-.656-1.95-.98-3.64-1.309-5.926-.167-1.86.325-4.906.895-6.261.41-.93.902-1.436 1.637-1.946z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
};

export const TriggerIconRebelGiveLogo = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" {...props}>
      <g fill="currentColor" fillRule="evenodd">
        <circle cx="30" cy="30" r="30" fill="none" />
        <path
          d="M37.206 30.018a1.77 1.77 0 011.34.581c.336.371.482.863.401 1.345l-.901 5.356 4.917 2.884-1.846 2.83-5.912-3.468c-.602-.353-.921-1.014-.81-1.677l.76-4.515-9.73.04 9.852 11.51L32.552 47l-12.16-14.206a1.595 1.595 0 01-.223-1.761c.29-.578.903-.948 1.578-.951l15.46-.064zM29.442 15c3.79 0 6.861 2.95 6.861 6.59 0 3.64-3.072 6.59-6.861 6.59-3.79 0-6.862-2.95-6.862-6.59 0-3.64 3.072-6.59 6.862-6.59zm.027 3.48c-1.774 0-3.211 1.38-3.211 3.083 0 1.704 1.437 3.084 3.211 3.084 1.773 0 3.211-1.38 3.211-3.084 0-1.703-1.438-3.084-3.211-3.084z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const TriggerIconGive = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle cx="30" cy="30" r="30" fill="none" />
        <path
          d="M15.788 38.522c2.354 0 3.894-1.056 4.598-2.112l.198 1.782h2.464v-8.118H15.26v2.64h4.928c-.176 1.1-1.298 3.036-4.18 3.036-2.618 0-4.928-1.826-4.928-5.346 0-3.696 2.552-5.302 4.906-5.302 2.53 0 3.828 1.606 4.224 2.992l2.904-1.034c-.77-2.398-3.036-4.796-7.128-4.796-4.224 0-7.986 3.102-7.986 8.14s3.586 8.118 7.788 8.118Zm11-12.914a1.793 1.793 0 0 0 1.804-1.782c0-1.012-.792-1.826-1.804-1.826-.99 0-1.804.814-1.804 1.826 0 .968.814 1.782 1.804 1.782Zm1.474 12.584V27.368h-2.926v10.824h2.926Zm8.58 0 4.202-10.824h-3.08l-2.574 7.26-2.684-7.26h-3.212l4.422 10.824h2.926Zm9.878.33c2.662 0 4.378-1.562 4.928-3.432l-2.442-.726c-.352.968-1.1 1.65-2.464 1.65-1.452 0-2.662-1.034-2.728-2.464h7.744c0-.044.044-.484.044-.902 0-3.476-2.002-5.61-5.346-5.61-2.772 0-5.324 2.244-5.324 5.698 0 3.652 2.618 5.786 5.588 5.786Zm2.2-6.974h-4.84c.066-.99.902-2.134 2.42-2.134 1.672 0 2.376 1.056 2.42 2.134Z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};

export const TriggerIconGivingHand = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" {...props}>
      <g fill="currentColor" fillRule="evenodd">
        <circle cx="30" cy="30" r="30" fill="none" />
        <g fill="currentColor" fillRule="nonzero">
          <path d="M42.366 27.152c-.642 0-1.284.245-1.772.73l-.002.002-2.295 2.295c.44.607.702 1.348.702 2.148a3.71 3.71 0 0 1-3.7 3.695h-4.77a.529.529 0 1 1 0-1.052h4.77a2.65 2.65 0 0 0 2.644-2.643c0-.51-.154-.982-.407-1.387-.03-.05-.07-.105-.106-.157a2.64 2.64 0 0 0-2.133-1.095h-8.474c-2.288.128-3.548 1.212-4.606 2.267l-1.524 1.52 6.574 6.555c.49-.491.833-.837 1.677-.837h7.411c1.819 0 3.338-.898 4.416-2.454 1.237-1.789 2.454-4.013 3.426-5.39.365-.516.602-1.11.625-1.725a2.328 2.328 0 0 0-.683-1.742 2.502 2.502 0 0 0-1.774-.73Zm-23.488 6.231a.525.525 0 0 0-.369.156l-3.175 3.167h-.001a.53.53 0 0 0 0 .75l7.942 7.92a.531.531 0 0 0 .75-.002l3.174-3.166v-.002a.526.526 0 0 0 .003-.746l-7.942-7.92a.534.534 0 0 0-.382-.157ZM36.345 17.524a6.53 6.53 0 0 1 1.067 3.595c0 3.669-2.99 6.663-6.664 6.663a6.71 6.71 0 0 1-3.866-1.233c-1.697-1.218-2.811-3.191-2.811-5.43 0-3.277 2.396-6.008 5.537-6.54a5.959 5.959 0 0 1 1.138-.108 6.67 6.67 0 0 1 5.6 3.053Zm-5.276 2.622v-2.032c.438.134.71.4.83.81.095.343.322.511.663.511a.614.614 0 0 0 .453-.177.53.53 0 0 0 .189-.42c0-.145-.035-.3-.118-.478a2.482 2.482 0 0 0-.367-.51 1.808 1.808 0 0 0-.688-.49c-.272-.112-.593-.176-.96-.222v-.52c0-.266-.118-.4-.332-.4-.037 0-.072 0-.106.011-.155.046-.227.167-.227.4v.51c-.722.066-1.27.265-1.648.632-.378.356-.57.81-.57 1.375 0 .421.095.775.284 1.043.2.278.45.488.771.632.31.156.7.288 1.163.41v2.265a1.569 1.569 0 0 1-.521-.244c-.012-.01-.023-.01-.035-.021a1.232 1.232 0 0 1-.32-.387 4.158 4.158 0 0 1-.239-.61.568.568 0 0 0-.226-.288.765.765 0 0 0-.404-.099.696.696 0 0 0-.487.177.58.58 0 0 0-.189.434c0 .21.046.421.143.643.095.22.25.43.45.63.118.124.261.234.427.325.095.067.215.131.333.187.307.132.664.22 1.066.266v1.32c0 .144.023.256.072.334.06.065.143.1.272.1.13 0 .212-.046.26-.135.035-.088.06-.22.06-.41v-1.22c.5-.034.924-.155 1.282-.365.367-.198.64-.466.829-.788a2.14 2.14 0 0 0 .272-1.042c0-.298-.06-.566-.178-.82a1.315 1.315 0 0 0-.392-.523.348.348 0 0 0-.106-.11c-.201-.178-.427-.311-.677-.4-.26-.093-.604-.194-1.03-.304Z" />
          <path d="M31.086 23.583v-2.101c.99.333.99.944.99 1.187 0 .233-.115.436-.362.613-.15.115-.36.215-.628.3ZM29.407 18.944c0-.28.163-.9 1.084-.9v1.834c-.584 0-.81-.223-.92-.355-.112-.134-.164-.325-.164-.579Z" />
        </g>
      </g>
    </svg>
  );
};

export const TriggerIconGivingHeart = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" {...props}>
      <g fill="currentColor" fillRule="evenodd">
        <circle cx="30" cy="30" r="30" fill="none" />
        <g fill="currentColor" fillRule="nonzero">
          <path d="M32.896 25.412c-1.12.033-1.964.52-2.53 1.46-.852-1.153-1.338-1.41-2.874-1.41-.885.098-1.573.493-2.089 1.136-.54.74-1.39 1.941.307 4.644 1.509 1.936 2.946 3.253 4.312 3.953a.925.925 0 0 0 .344.1.925.925 0 0 0 .344-.1c1.366-.685 2.812-2.02 4.336-4.002 1.763-2.654.627-4.324.184-4.768-.614-.667-1.4-1.013-2.334-1.013ZM22.235 30.353c0 2.353-3.53 2.353-3.53 0s3.53-2.353 3.53 0M38.47 30.353C38.47 28 42 28 42 30.353s-3.53 2.353-3.53 0Z" />
          <path d="M42.353 20.185h-24a4.235 4.235 0 0 0-4.235 4.235v11.294a4.235 4.235 0 0 0 4.235 4.236h24a4.235 4.235 0 0 0 4.235-4.236V24.42a4.235 4.235 0 0 0-4.235-4.235Zm0 2.118c1.17 0 2.118.948 2.118 2.117v11.294c0 1.17-.949 2.118-2.118 2.118h-24a2.118 2.118 0 0 1-2.118-2.118V24.42c0-1.17.948-2.117 2.118-2.117h24Z" />
        </g>
      </g>
    </svg>
  );
};

export const Spinner = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}>
      <path
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="4.3"
        d="M18 33a15 15 0 1 0-15-15"
      />
    </svg>
  );
};

export const AnimatedSpinner = styled(Spinner)`
  animation: ${rotate} 800ms linear infinite;
  height: 3.6rem;
  width: 3.6rem;
`;

export const Person = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 36" {...props}>
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M5.2 8.26a8.3 8.3 0 0 1 16.6 0c0 4.55-3.72 8.2-8.3 8.2a8.29 8.29 0 0 1-8.3-8.2zM27 32.13c-.12-7.26-5.8-13.23-12.84-13.6a13.2 13.2 0 0 0-9.98 3.81A14.01 14.01 0 0 0 0 32.44 3.57 3.57 0 0 0 3.52 36h19.95c.96 0 1.86-.37 2.51-1.05A3.64 3.64 0 0 0 27 32.43v-.3z"
      />
    </svg>
  );
};

export const X = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <path
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={props.strokeWidth || 2.8}
        d="M1.5 1.5l13 13M14.5 1.5l-13 13"
      />
    </svg>
  );
};

export const XRounded = (props) => {
  return (
    <SVG viewBox="0 0 36 36" {...props}>
      <path
        d="M24.364 11.636a2 2 0 010 2.828L20.828 18l3.536 3.536a2 2 0 11-2.828 2.828L18 20.828l-3.536 3.536a2 2 0 11-2.828-2.828L15.172 18l-3.536-3.536a2 2 0 112.828-2.828L18 15.172l3.536-3.536a2 2 0 012.828 0z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </SVG>
  );
};

export const PlusRounded = (props) => {
  return <XRounded {...props} style={{ ...props.style, transform: 'rotate(45deg)', transformOrigin: 'center' }} />;
};

export const MinusRounded = (props) => {
  return (
    <SVG viewBox="0 0 30 30" {...props}>
      <line x1="10.08" y1="15" x2="19.92" y2="15" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </SVG>
  );
};

export const PlusRoundedForCounter = (props) => {
  return (
    <SVG viewBox="0 0 30 30" {...props}>
      <line x1="10.08" y1="15" x2="19.92" y2="15" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <line x1="15" y1="10.08" x2="15" y2="19.92" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </SVG>
  );
};

export const CircleExclamationmark = (props) => {
  return (
    <SVG viewBox="0 0 36 36" {...props}>
      <path fill="currentColor" d="M18 0a18 18 0 110 36 18 18 0 010-36z" />
      <path
        fill="#FFF"
        d="M18 9.5a3 3 0 013 3v4a3 3 0 01-6 0v-4a3 3 0 013-3zm0 12h.18a3.01 3.01 0 012.81 2.82l.01.18v.18a3.01 3.01 0 01-2.82 2.81l-.18.01h-.18a3.01 3.01 0 01-2.81-2.82L15 24.5v-.18a3.01 3.01 0 012.82-2.81l.18-.01z"
      />
    </SVG>
  );
};

export const CircleInfo = styled(CircleExclamationmark)`
  transform: rotate(180deg);
  transform-origin: center;
`;

export const ExclamationMark = (props) => {
  return (
    <SVG viewBox="0 0 36 36" {...props}>
      <circle cx="36" cy="36" r="36" fill="none" />
      <path
        fill="currentColor"
        d="M18 9.5a3 3 0 013 3v4a3 3 0 01-6 0v-4a3 3 0 013-3zm0 12h.18a3.01 3.01 0 012.81 2.82l.01.18v.18a3.01 3.01 0 01-2.82 2.81l-.18.01h-.18a3.01 3.01 0 01-2.81-2.82L15 24.5v-.18a3.01 3.01 0 012.82-2.81l.18-.01z"
      />
    </SVG>
  );
};

export const Info = styled(ExclamationMark)`
  transform: rotate(180deg);
  transform-origin: center;
`;

const CIRCLE_ICON_VARIANTS = deepFreeze({
  down: { transform: 'rotate(0deg)' },
  downLeft: { transform: 'rotate(45deg)' },
  left: { transform: 'rotate(90deg)' },
  upLeft: { transform: 'rotate(135deg)' },
  up: { transform: 'rotate(180deg)' },
  upRight: { transform: 'rotate(225deg)' },
  right: { transform: 'rotate(270deg)' },
  downRight: { transform: 'rotate(315deg)' },
});

export const CircleIcon = (props) => {
  const { direction, width, ...otherProps } = props;

  const style = useSpring({
    to: CIRCLE_ICON_VARIANTS[direction],
    config: {
      friction: 55,
      mass: 0.5,
      tension: 1000,
    },
  });

  return (
    <CircleIconContainer {...otherProps} width={props.width} style={style}>
      {props.children}
    </CircleIconContainer>
  );
};

CircleIcon.propTypes = {
  children: PropTypes.node,
  direction: PropTypes.oneOf(['down', 'downLeft', 'left', 'upLeft', 'up', 'upRight', 'right', 'downRight']),
  width: PropTypes.string,
};

const CIRCLE_ICON_FLIP_VARIANTS = deepFreeze({
  down: { transform: 'rotateX(0deg)' },
  up: { transform: 'rotateX(180deg)' },
});

export const CircleIconFlip = (props) => {
  const { direction, width, ...otherProps } = props;

  const style = useSpring({
    to: CIRCLE_ICON_FLIP_VARIANTS[direction],
    config: {
      friction: 55,
      mass: 0.5,
      tension: 2000,
    },
  });

  return (
    <CircleIconContainer {...otherProps} width={props.width}>
      <IconContainer style={style}>{props.children}</IconContainer>
    </CircleIconContainer>
  );
};

CircleIconFlip.propTypes = {
  children: PropTypes.node,
  direction: PropTypes.oneOf(['down', 'up']),
  width: PropTypes.string,
};

export const CircleIconContainer = styled(animated.span).attrs({
  onTouchStart: () => true,
})`
  position: relative;
  color: currentColor;
  width: ${(props) => props.width || '2.4rem'};
  height: ${(props) => props.width || '2.4rem'};
  border-radius: 100%;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 100%;
    background: currentColor;
    opacity: 0.15;
  }

  svg {
    width: 100%;
  }
`;

const IconContainer = styled(animated.span)`
  width: 100%;
  height: 100%;
`;

export const CircleIconArrow = (props) => {
  return (
    <CircleIcon {...props}>
      <ArrowDown />
    </CircleIcon>
  );
};

export const CircleIconAngle = (props) => {
  return (
    <CircleIcon {...props}>
      <AngleDown />
    </CircleIcon>
  );
};

export const CircleIconFlipAngle = (props) => {
  return (
    <CircleIconFlip {...props}>
      <AngleDown />
    </CircleIconFlip>
  );
};

CircleIconFlipAngle.propTypes = {
  direction: PropTypes.oneOf(['down', 'up']),
  width: PropTypes.string,
};

export const IconPlaid = (props) => {
  return (
    <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
      <path
        d="M12.688 0 2.784 2.568.055 12.43 3.47 15.9 0 19.312l2.569 9.904 9.86 2.728 3.47-3.413L19.312 32l9.904-2.568 2.728-9.862-3.413-3.469L32 12.69l-2.569-9.905L19.57.056l-3.468 3.413L12.688 0ZM6.61 4.465l5.216-1.354 2.282 2.32-3.327 3.273L6.61 4.465Zm11.452.996 2.318-2.28 5.194 1.437-4.239 4.17-3.273-3.327ZM3.18 11.62l1.437-5.194 4.17 4.238-3.327 3.274-2.28-2.32v.002Zm20.115-.838 4.24-4.172 1.351 5.217-2.317 2.281-3.274-3.326Zm-10.554-.086 3.327-3.273 3.273 3.327-3.326 3.273-3.274-3.327Zm-5.32 5.234 3.327-3.273 3.275 3.327-3.328 3.273-3.273-3.327Zm10.555.086 3.326-3.273 3.274 3.327-3.327 3.273-3.273-3.327ZM3.111 20.173 5.43 17.89l3.273 3.328-4.238 4.17-1.354-5.216Zm9.546 1.077 3.327-3.273 3.273 3.327-3.326 3.273-3.274-3.327Zm10.553.086 3.327-3.273 2.282 2.318-1.437 5.194-4.172-4.239ZM6.425 27.383l4.238-4.172 3.275 3.327-2.319 2.282-5.194-1.438Zm11.466-.813 3.327-3.274 4.17 4.24-5.216 1.353-2.28-2.32Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const IconMasterCard = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 152.4 108"
      style={{ enableBackground: 'new 0 0 152.4 108' }}
      {...props}
    >
      <path style={{ fill: 'none' }} d="M0 0h152.4v108H0z" />
      <path style={{ fill: '#ff5f00' }} d="M60.4 25.7h31.5v56.6H60.4z" />
      <path
        d="M62.4 54c0-11 5.1-21.5 13.7-28.3-15.6-12.3-38.3-9.6-50.6 6.1C13.3 47.4 16 70 31.7 82.3c13.1 10.3 31.4 10.3 44.5 0C67.5 75.5 62.4 65 62.4 54z"
        style={{ fill: '#eb001b' }}
      />
      <path
        d="M134.4 54c0 19.9-16.1 36-36 36-8.1 0-15.9-2.7-22.2-7.7 15.6-12.3 18.3-34.9 6-50.6-1.8-2.2-3.8-4.3-6-6 15.6-12.3 38.3-9.6 50.5 6.1 5 6.3 7.7 14.1 7.7 22.2z"
        style={{ fill: '#f79e1b' }}
      />
    </svg>
  );
};

export const IconVisa = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 3384.54 2077.85"
      style={{ enableBackground: 'new 0 0 3384.54 2077.85', transform: 'scale(1.3)' }}
      {...props}
    >
      <path
        d="m1461.26 739.84-251.37 599.74h-164l-123.7-478.62c-7.51-29.48-14.04-40.28-36.88-52.7-37.29-20.23-98.87-39.21-153.05-50.99l3.68-17.43h263.99c33.65 0 63.9 22.4 71.54 61.15l65.33 347.04 161.46-408.2h163zm642.58 403.93c.66-158.29-218.88-167.01-217.37-237.72.47-21.52 20.96-44.4 65.81-50.24 22.23-2.91 83.48-5.13 152.95 26.84l27.25-127.18c-37.33-13.55-85.36-26.59-145.12-26.59-153.35 0-261.27 81.52-262.18 198.25-.99 86.34 77.03 134.52 135.81 163.21 60.47 29.38 80.76 48.26 80.53 74.54-.43 40.23-48.23 57.99-92.9 58.69-77.98 1.2-123.23-21.1-159.3-37.87l-28.12 131.39c36.25 16.63 103.16 31.14 172.53 31.87 162.99 0 269.61-80.51 270.11-205.19m404.94 195.81h143.49l-125.25-599.74h-132.44c-29.78 0-54.9 17.34-66.02 44l-232.81 555.74h162.91L2291 1250h199.05l18.73 89.58zm-173.11-212.5 81.66-225.18 47 225.18h-128.66zm-652.74-387.24-128.29 599.74H1399.5l128.34-599.74h155.09z"
        style={{ fill: '#1434cb' }}
      />
    </svg>
  );
};

export const IconAmex = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70" style={{ transform: 'scale(1.3)' }} {...props}>
      <path
        style={{ fill: '#0071ce' }}
        d="m59.4 49.7-2.6-2.9-2.7 2.9H37.4V36.2h-5.3l6.6-15.1h6.4l2.3 5.2v-5.2h8l1.4 3.9 1.4-3.9h6.1v-2.3c0-1.4-1.1-2.5-2.5-2.5H8.2c-1.4 0-2.5 1.1-2.5 2.5v32.5c0 1.4 1.1 2.5 2.5 2.5h53.6c1.4 0 2.5-1.1 2.5-2.5v-1.6h-4.9z"
      />
      <path
        style={{ fill: '#0071ce' }}
        d="M60.1 48.1h4.2l-5.5-5.9 5.5-5.8h-4.1l-3.5 3.8-3.4-3.8h-4.2l5.6 5.9-5.6 5.8h4.1l3.5-3.8 3.4 3.8z"
      />
      <path
        style={{ fill: '#0071ce' }}
        d="M42.4 45.4v-1.8H49v-2.7h-6.6v-1.8h6.7v-2.7h-9.9v11.7h9.9v-2.7h-6.7zM61.2 34.7h3V22.9l-4.8.1-2.6 7.3-2.7-7.3h-5v11.7h3.2v-8.2l3 8.2h2.8l3.1-8.2v8.2z"
      />
      <path
        style={{ fill: '#0071ce' }}
        d="M44 23h-4.1l-5.2 11.7h3.5l1-2.3h5.4l1 2.3h3.6L44 23zm-3.7 6.7 1.6-3.8 1.6 3.8h-3.2zM61.4 41.9l2.9 3.2v-6.4l-2.9 3.2z"
      />
    </svg>
  );
};

export const IconDiscover = (props) => {
  return <img src={ImgDiscoverCard} alt="Discover" {...props} />;
};
